function extractOrigin(url) {
  try {
    const { origin } = new URL(url)
    return origin
  } catch {
    return url.replace(/\/$/, '')
  }
}

export const BACKEND_ORIGIN = extractOrigin(import.meta.env.VITE_JSON_SERVER_URL || 'http://localhost:49710')

export function apiUrl(path = '') {
  if (!path) return BACKEND_ORIGIN
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${BACKEND_ORIGIN}${normalizedPath}`
}
